import React from 'react';
import JobDetailLayout from '../../components/JobDetailLayout';

const PhysiotherapistJob = () => {
  const sections = [
    {
      title: 'About B & N Enterprise',
      paragraphs: [
        'B & N Enterprise provides warm, professional care across Weston, Canberra, and the wider ACT. We offer person-centred support to older Australians and people living with disability, helping them stay independent and live well. Our multidisciplinary team works together to care for the whole person, looking after physical, emotional, and social wellbeing.'
      ]
    },
    {
      title: 'Role Overview',
      paragraphs: [
        'We are looking for a qualified, caring Physiotherapist to join our allied health team. In this role you will provide physiotherapy to the people we support in their own homes and community settings across Weston, Canberra, and the wider ACT. You will work with a varied group, including older adults, people living with disability, and those recovering from injury or illness.',
        "It is a great opportunity for a physiotherapist who values independence, professional growth, and making a real difference in people's lives. You will have the freedom to manage your own caseload, with the backing of an experienced multidisciplinary team."
      ]
    },
    {
      title: 'Key Responsibilities',
      items: [
        "Conduct comprehensive assessments of clients' physical function and mobility needs",
        'Develop and implement evidence-based treatment plans tailored to individual goals',
        'Provide therapeutic interventions to improve strength, balance, mobility, and function',
        'Prescribe and review assistive devices and mobility aids',
        'Educate clients and families on exercise programs and self-management strategies',
        'Collaborate with multidisciplinary teams including doctors, nurses, and occupational therapists',
        'Maintain accurate clinical documentation and progress reports',
        'Participate in case conferences and care planning meetings',
        'Ensure compliance with AHPRA standards and NDIS quality framework'
      ]
    },
    {
      title: 'Essential Requirements',
      items: [
        'Current registration with the Physiotherapy Board of Australia (AHPRA)',
        'Valid working rights in Australia',
        "Bachelor's or Master's degree in Physiotherapy from an accredited institution",
        'Strong clinical assessment and treatment skills',
        'Excellent communication and interpersonal abilities',
        'Ability to work autonomously and as part of a multidisciplinary team',
        'Current Professional Indemnity Insurance',
        'Current Working with Vulnerable People (WWVP) registration with Access Canberra, or willingness to obtain before commencing (required under ACT law)',
        'A National Police Check issued within the last 3 years, or a current NDIS Worker Screening Clearance',
        "Valid ACT driver's licence and willingness to travel to client homes",
        'Current First Aid and CPR certification'
      ]
    },
    {
      title: 'Desirable Qualifications and Experience',
      items: [
        'Experience in aged care, disability, or community-based physiotherapy',
        'Post-graduate qualifications in gerontology, neurology, or rehabilitation',
        'Experience with NDIS service delivery and documentation',
        'Knowledge of assistive technology and equipment prescription',
        'Manual therapy and exercise prescription skills',
        'Experience in falls prevention and balance training programs',
        'Understanding of chronic disease management in older adults'
      ]
    },
    {
      title: 'What We Offer',
      items: [
        'Salary in line with the Health Professionals and Support Services Award 2020, commensurate with your experience and qualifications',
        'Salary packaging options available to maximise take-home pay',
        'Flexible working arrangements including part-time and full-time options',
        'Professional development support and continuing education opportunities',
        'Access to modern equipment and clinical resources',
        'Supportive team environment with regular clinical supervision',
        'Vehicle allowance for community visits',
        'Opportunity to make a genuine impact in your local community'
      ]
    }
  ];

  return (
    <JobDetailLayout
      breadcrumbLabel="Physiotherapist"
      title="Physiotherapist"
      meta={[
        { label: 'Location', value: '23 Mahony Ct, Weston ACT 2611' },
        { label: 'Employment', value: 'Full-time, part-time' },
        { label: 'Department', value: 'Allied Health' },
        { label: 'Registration', value: 'AHPRA required' }
      ]}
      applyLink="/jobs/physiotherapist/apply"
      applyText="Join our allied health team and help clients achieve their mobility and independence goals."
      recruitmentNote="Shortlisted candidates will be contacted for interview. AHPRA registration verification, Working with Vulnerable People (WWVP) registration, a police or NDIS worker screening check, and reference checks form part of our recruitment process."
      sections={sections}
      equalOpportunity="B & N Enterprise is an equal opportunity employer. We warmly welcome applications from all suitably qualified people, whatever their age, gender, cultural background, disability, sexual orientation, or religious beliefs. We are committed to an inclusive workplace that reflects the diverse community we serve."
    />
  );
};

export default PhysiotherapistJob;
